export default {
  UP: 'UP',
  DOWN: 'DOWN',
};
